import { render, staticRenderFns } from "./OrganCertificateDataManage.vue?vue&type=template&id=5f9432a6&scoped=true"
import script from "./OrganCertificateDataManage.vue?vue&type=script&lang=js"
export * from "./OrganCertificateDataManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9432a6",
  null
  
)

export default component.exports